import {Grid, Loader} from '@logistics-frontend/blocks'
import React from 'react'
import {useParams} from 'react-router-dom'

import {useTariffsList} from '../../hooks'
import {TariffsPageParams, TariffsProps, TariffZonesItem} from '../../types'
import {TariffDetailsColumn} from '../tariff-details-column'
import {TariffsColumn} from '../tariffs-column'

type Props = Omit<TariffsProps, 'defaultCountry' | 'fetchZones'> & {
  tariffZones: TariffZonesItem[]
}

const TariffsWithDetails: React.FC<Props> = ({
  fetchTariffs,
  urls,
  disclaimerKey,
  isPostPaymentEnabled,
  surgeLink,
  tariffZones,
}) => {
  const {zone, country} = useParams<TariffsPageParams>()
  const {isTariffPending, tariffs} = useTariffsList(fetchTariffs, zone, country)

  return (
    <>
      <Grid xs={3} item>
        {isTariffPending ? <Loader /> : <TariffsColumn tariffList={tariffs} urls={urls} />}
      </Grid>
      <Grid xs={6} item>
        {isTariffPending ? (
          <Loader />
        ) : (
          <TariffDetailsColumn
            disclaimerKey={disclaimerKey}
            isPostPaymentEnabled={isPostPaymentEnabled}
            surgeLink={surgeLink}
            tariffList={tariffs}
            tariffZones={tariffZones}
          />
        )}
      </Grid>
    </>
  )
}

export default TariffsWithDetails
